/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaSubscribeNewsletterFormViewProps } from './citta-subscribe-newsletter-form';

/**
 *
 * ICittaProductSkuView component
 * @extends {React.PureComponent<ICittaProductSkuViewProps>}
 */
export class ICittaSubscribeNewsletterFormView extends React.PureComponent<ICittaSubscribeNewsletterFormViewProps> {

    public render(): JSX.Element | null {
        const {
          SubscribeWrapper,
          subscribeResponse,
          subscribeForm,
          responseSuccess,
          formErrors,
          formErrorsNodeProps,
          successResponseNodeProps,
          showSuccessResponse,
          successResponse
        } = this.props;

        const {
          FormWrapper,
          FormContainer,
          firstAndLastNameInput,
          emailInput,
          checkboxPrivacyPolicy,
          subscribeButtton,
          reCaptcha,
          subscribeThanks
        } = subscribeForm;

        return (
            <Module {...SubscribeWrapper} >
                {subscribeResponse}
                {showSuccessResponse ?
                    <Node {...successResponseNodeProps}>
                        {successResponse}
                    </Node>
                    : <Node {...FormWrapper} >
                        <Node {...FormContainer} >
                            {firstAndLastNameInput}
                            {emailInput}
                            {checkboxPrivacyPolicy}
                            {reCaptcha}
                            {responseSuccess ? subscribeThanks : subscribeButtton}
                        </Node>
                        <Node {...formErrorsNodeProps}>
                            {formErrors}
                        </Node>
                    </Node>
                }
            </Module>
        );
    }
}
export default ICittaSubscribeNewsletterFormView;
